var _style, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRacerangerIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 495.69 495.69",
  style: {
    enableBackground: "new 0 0 495.69 495.69"
  },
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{clip-path:url(#SVGID_13_);}\n\t.st12{fill:#5FC3B0;}\n\t.st13{fill:#5DC3B0;}\n\t.st14{fill:#5DC3B1;}\n\t.st15{fill:#5CC3B0;}\n\t.st16{fill:#5AC1B1;}\n\t.st17{fill:#59C1B1;}\n\t.st18{fill:#58C0B1;}\n\t.st19{fill:#58C0B2;}\n\t.st20{fill:#54C0B2;}\n\t.st21{fill:#53BFB3;}\n\t.st22{fill:#51BFB3;}\n\t.st23{fill:#51BEB5;}\n\t.st24{fill:#50BEB4;}\n\t.st25{fill:#4EBEB5;}\n\t.st26{fill:#4DBDB5;}\n\t.st27{fill:#4BBDB6;}\n\t.st28{fill:#49BCB6;}\n\t.st29{fill:#46BCB8;}\n\t.st30{fill:#45BCB7;}\n\t.st31{fill:#43BBB8;}\n\t.st32{fill:#41BBB8;}\n\t.st33{fill:#3FBBB9;}\n\t.st34{fill:#3DBAB9;}\n\t.st35{fill:#3ABABA;}\n\t.st36{fill:#36B9BA;}\n\t.st37{fill:#33B9BB;}\n\t.st38{fill:#31B8BA;}\n\t.st39{fill:#2FB7BB;}\n\t.st40{fill:#2CB7BB;}\n\t.st41{fill:#2AB6BC;}\n\t.st42{fill:#26B6BC;}\n\t.st43{fill:#21B6BD;}\n\t.st44{fill:#1EB5BD;}\n\t.st45{fill:#18B5BF;}\n\t.st46{fill:#0FB6BF;}\n\t.st47{fill:#0AB4BF;}\n\t.st48{fill:#00B5C0;}\n\t.st49{fill:#07B4C1;}\n\t.st50{fill:#09B4C2;}\n\t.st51{fill:#0FB4C3;}\n\t.st52{fill:#0CB3C2;}\n\t.st53{fill:#0AB3C4;}\n\t.st54{fill:#02B2C5;}\n\t.st55{fill:#01B2C5;}\n\t.st56{fill:#02B1C6;}\n\t.st57{fill:#03B1C7;}\n\t.st58{fill:#00B0C7;}\n\t.st59{fill:#03B0C8;}\n\t.st60{fill:#00AFC9;}\n\t.st61{fill:#00AFCA;}\n\t.st62{fill:#00AECA;}\n\t.st63{fill:#07AECB;}\n\t.st64{fill:#09ADCC;}\n\t.st65{fill:#05ADCD;}\n\t.st66{fill:#00ACCE;}\n\t.st67{fill:#00ACCF;}\n\t.st68{fill:#00ABCF;}\n\t.st69{fill:#00ABD0;}\n\t.st70{fill:#00AAD1;}\n\t.st71{fill:#00AAD3;}\n\t.st72{fill:#00A9D2;}\n\t.st73{fill:#00A9D3;}\n\t.st74{fill:#00A8D4;}\n\t.st75{fill:#02A8D4;}\n\t.st76{fill:#04A7D5;}\n\t.st77{fill:#01A7D7;}\n\t.st78{fill:#04A6D7;}\n\t.st79{fill:#01A6D8;}\n\t.st80{fill:#04A5D9;}\n\t.st81{fill:#00A5DA;}\n\t.st82{fill:#07A4D9;}\n\t.st83{fill:#04A4DA;}\n\t.st84{fill:#0BA4DB;}\n\t.st85{fill:#02A3DC;}\n\t.st86{fill:#0BA3DD;}\n\t.st87{fill:#10A2DC;}\n\t.st88{fill:#13A1DC;}\n\t.st89{fill:#18A1DC;}\n\t.st90{fill:#17A0DB;}\n\t.st91{fill:#1BA0DB;}\n\t.st92{fill:#20A0DB;}\n\t.st93{fill:#010101;}\n\t.st94{clip-path:url(#SVGID_15_);}\n\t.st95{clip-path:url(#SVGID_17_);}\n\t.st96{fill:url(#SVGID_18_);}\n\t.st97{fill:url(#SVGID_19_);}\n\t.st98{clip-path:url(#SVGID_21_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_20_",
  d: "M477.65,242.41c-0.08-2.21-1.89-3.96-4.1-3.96h-59.56v-97.78c-0.01-3.17-2.59-5.74-5.76-5.74h-90.59 c-34,0-61.08,19.17-69.4,46.83c-8.19-27.83-35.36-47.16-69.5-47.16H88.15c-3.18,0-5.76,2.58-5.76,5.76v97.78H40.79 c-0.32-0.05-0.64-0.08-0.97-0.08H22.13c-2.21,0-4.03,1.76-4.11,3.97c-0.12,3.28-0.18,6.57-0.19,9.89c0,3.2,0.06,6.38,0.19,9.55 c0.08,2.21,1.89,3.97,4.11,3.97h60.26v89.58c0,3.18,2.58,5.76,5.76,5.76h16.1c3.18,0,5.76-2.58,5.76-5.76v-89.58h55.17 l59.22,92.64c1.06,1.66,2.89,2.66,4.85,2.65h16.69c0.62,0.22,1.28,0.34,1.94,0.34h19.25c1.97,0,3.8-1,4.86-2.66l59.22-92.66h55.17 v89.58c0.01,3.17,2.58,5.74,5.75,5.75h16.1c3.18,0,5.76-2.58,5.76-5.76c0,0,0,0,0-0.01v-89.58h41.39c0.16,0,0.31,0,0.47,0h17.73 c2.21,0,4.02-1.75,4.1-3.96c0.13-3.28,0.19-6.58,0.19-9.91C477.83,248.71,477.76,245.56,477.65,242.41z M110.01,238.11v-76.23 h68.73c25.79,0,43.8,15.54,43.8,37.79c0,22.64-18.03,38.44-43.8,38.44H110.01z M248.29,343.94l-51.18-80.35 c25.44-5.65,44.33-22.73,51.02-45.34c6.61,22.77,25.56,40,51.12,45.68L248.29,343.94z M386.36,238.45h-68.73 c-25.79,0-43.8-15.81-43.8-38.44c0-22.26,18.03-37.8,43.8-37.8h68.73L386.36,238.45z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_1_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_20_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#SVGID_1_)"
  }
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 126.52,
  className: "st12",
  width: 1287.16,
  height: 16.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 143.01,
  className: "st12",
  width: 1287.16,
  height: 2.12
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 145.14,
  className: "st13",
  width: 1287.16,
  height: 2.12
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 147.27,
  className: "st14",
  width: 1287.16,
  height: 2.12
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 149.39,
  className: "st15",
  width: 1287.16,
  height: 2.12
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 151.52,
  className: "st16",
  width: 1287.16,
  height: 2.12
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 153.65,
  className: "st17",
  width: 1287.16,
  height: 2.12
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 155.77,
  className: "st18",
  width: 1287.16,
  height: 2.12
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 157.9,
  className: "st19",
  width: 1287.16,
  height: 2.12
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 160.03,
  className: "st20",
  width: 1287.16,
  height: 2.12
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 162.15,
  className: "st21",
  width: 1287.16,
  height: 2.12
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 164.28,
  className: "st22",
  width: 1287.16,
  height: 2.12
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 166.41,
  className: "st23",
  width: 1287.16,
  height: 2.12
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 168.53,
  className: "st24",
  width: 1287.16,
  height: 2.12
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 170.66,
  className: "st25",
  width: 1287.16,
  height: 2.12
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 172.78,
  className: "st26",
  width: 1287.16,
  height: 2.12
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 174.91,
  className: "st27",
  width: 1287.16,
  height: 2.12
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 177.04,
  className: "st28",
  width: 1287.16,
  height: 2.12
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 179.16,
  className: "st29",
  width: 1287.16,
  height: 2.12
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 181.29,
  className: "st30",
  width: 1287.16,
  height: 2.12
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 183.42,
  className: "st31",
  width: 1287.16,
  height: 2.12
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 185.54,
  className: "st32",
  width: 1287.16,
  height: 2.12
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 187.67,
  className: "st33",
  width: 1287.16,
  height: 2.12
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 189.8,
  className: "st34",
  width: 1287.16,
  height: 2.12
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 191.92,
  className: "st35",
  width: 1287.16,
  height: 2.12
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 194.05,
  className: "st36",
  width: 1287.16,
  height: 2.12
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 196.18,
  className: "st37",
  width: 1287.16,
  height: 2.12
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 198.3,
  className: "st38",
  width: 1287.16,
  height: 2.12
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 200.43,
  className: "st39",
  width: 1287.16,
  height: 2.12
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 202.56,
  className: "st40",
  width: 1287.16,
  height: 2.12
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 204.68,
  className: "st41",
  width: 1287.16,
  height: 2.12
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 206.81,
  className: "st42",
  width: 1287.16,
  height: 2.12
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 208.94,
  className: "st43",
  width: 1287.16,
  height: 2.12
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 211.06,
  className: "st44",
  width: 1287.16,
  height: 2.12
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 213.19,
  className: "st45",
  width: 1287.16,
  height: 2.12
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 215.31,
  className: "st46",
  width: 1287.16,
  height: 2.12
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 217.44,
  className: "st47",
  width: 1287.16,
  height: 2.12
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 219.57,
  className: "st48",
  width: 1287.16,
  height: 2.12
})), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 221.69,
  className: "st49",
  width: 1287.16,
  height: 2.12
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 223.82,
  className: "st50",
  width: 1287.16,
  height: 2.12
})), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 225.95,
  className: "st50",
  width: 1287.16,
  height: 2.12
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 228.07,
  className: "st51",
  width: 1287.16,
  height: 2.12
})), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 230.2,
  className: "st52",
  width: 1287.16,
  height: 2.12
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 232.33,
  className: "st53",
  width: 1287.16,
  height: 2.12
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 234.45,
  className: "st53",
  width: 1287.16,
  height: 2.12
})), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 236.58,
  className: "st54",
  width: 1287.16,
  height: 2.12
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 238.71,
  className: "st54",
  width: 1287.16,
  height: 2.12
})), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 240.83,
  className: "st55",
  width: 1287.16,
  height: 2.12
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 242.96,
  className: "st56",
  width: 1287.16,
  height: 2.12
})), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 245.09,
  className: "st57",
  width: 1287.16,
  height: 2.12
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 247.21,
  className: "st58",
  width: 1287.16,
  height: 2.12
})), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 249.34,
  className: "st59",
  width: 1287.16,
  height: 2.12
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 251.47,
  className: "st59",
  width: 1287.16,
  height: 2.12
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 253.59,
  className: "st60",
  width: 1287.16,
  height: 2.12
})), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 255.72,
  className: "st60",
  width: 1287.16,
  height: 2.12
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 257.84,
  className: "st61",
  width: 1287.16,
  height: 2.12
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 259.97,
  className: "st62",
  width: 1287.16,
  height: 2.12
})), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 262.1,
  className: "st63",
  width: 1287.16,
  height: 2.12
})), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 264.22,
  className: "st63",
  width: 1287.16,
  height: 2.12
})), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 266.35,
  className: "st64",
  width: 1287.16,
  height: 2.12
})), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 268.48,
  className: "st65",
  width: 1287.16,
  height: 2.12
})), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 270.6,
  className: "st65",
  width: 1287.16,
  height: 2.12
})), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 272.73,
  className: "st66",
  width: 1287.16,
  height: 2.12
})), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 274.86,
  className: "st66",
  width: 1287.16,
  height: 2.12
})), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 276.98,
  className: "st67",
  width: 1287.16,
  height: 2.12
})), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 279.11,
  className: "st68",
  width: 1287.16,
  height: 2.12
})), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 281.24,
  className: "st69",
  width: 1287.16,
  height: 2.12
})), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 283.36,
  className: "st69",
  width: 1287.16,
  height: 2.12
})), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 285.49,
  className: "st70",
  width: 1287.16,
  height: 2.12
})), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 287.62,
  className: "st70",
  width: 1287.16,
  height: 2.12
})), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 289.74,
  className: "st71",
  width: 1287.16,
  height: 2.12
})), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 291.87,
  className: "st72",
  width: 1287.16,
  height: 2.12
})), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 294,
  className: "st73",
  width: 1287.16,
  height: 2.12
})), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 296.12,
  className: "st73",
  width: 1287.16,
  height: 2.12
})), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 298.25,
  className: "st74",
  width: 1287.16,
  height: 2.12
})), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 300.37,
  className: "st74",
  width: 1287.16,
  height: 2.12
})), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 302.5,
  className: "st75",
  width: 1287.16,
  height: 2.12
})), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 304.63,
  className: "st76",
  width: 1287.16,
  height: 2.12
})), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 306.75,
  className: "st76",
  width: 1287.16,
  height: 2.12
})), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 308.88,
  className: "st77",
  width: 1287.16,
  height: 2.12
})), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 311.01,
  className: "st78",
  width: 1287.16,
  height: 2.12
})), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 313.13,
  className: "st79",
  width: 1287.16,
  height: 2.12
})), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 315.26,
  className: "st79",
  width: 1287.16,
  height: 2.12
})), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 317.39,
  className: "st80",
  width: 1287.16,
  height: 2.12
})), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 319.51,
  className: "st80",
  width: 1287.16,
  height: 2.12
})), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 321.64,
  className: "st81",
  width: 1287.16,
  height: 2.12
})), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 323.77,
  className: "st82",
  width: 1287.16,
  height: 2.12
})), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 325.89,
  className: "st83",
  width: 1287.16,
  height: 2.12
})), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 328.02,
  className: "st84",
  width: 1287.16,
  height: 2.12
})), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 330.15,
  className: "st85",
  width: 1287.16,
  height: 2.12
})), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 332.27,
  className: "st86",
  width: 1287.16,
  height: 2.12
})), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 334.4,
  className: "st86",
  width: 1287.16,
  height: 2.12
})), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 336.53,
  className: "st87",
  width: 1287.16,
  height: 2.12
})), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 338.65,
  className: "st87",
  width: 1287.16,
  height: 2.12
})), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 340.78,
  className: "st88",
  width: 1287.16,
  height: 2.12
})), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 342.9,
  className: "st89",
  width: 1287.16,
  height: 2.12
})), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 345.03,
  className: "st90",
  width: 1287.16,
  height: 2.12
})), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 347.16,
  className: "st90",
  width: 1287.16,
  height: 2.12
})), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 349.28,
  className: "st91",
  width: 1287.16,
  height: 2.12
})), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 351.41,
  className: "st92",
  width: 1287.16,
  height: 2.12
})), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
  x: -369.74,
  y: 353.54,
  className: "st92",
  width: 1287.16,
  height: 23.77
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRacerangerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "367d34dc595500bfe8238be5a1ddc8e7.svg";